<div [class]="'unity-form-group checkbox ' + classes">
  <div class="unity-form-row">
    <label for="{{ labelFor }}">
      <input
        id="{{ labelFor }}"
        type="checkbox"
        [checked]="checked"
        [(ngModel)]="inputModel"
        (change)="onChange.emit()"
      />
      <span class="input-icon">
        <svg class="unity-icon unity-icon-checkmark">
          <use xlink:href="#unity-icon-checkmark"></use>
        </svg>
      </span>
      <span *ngIf="label">{{ label }}</span>
    </label>
  </div>
</div>
